import { StyledText } from './styles';

export default StyledText;
